<template>
  <div :class="{'invalid': invalid}">
    <multiselect
        v-model="selectedMarket"
        :placeholder="$t('components.multiselect.marketplace_placeholder')"
        label="text"
        track-by="marketplace_id"
        :options="filteredMarketPlaces"
        :multiple="multiple"
        :deselectLabel="$t('components.multiselect.deselectLabel')"
        :tagPlaceholder="$t('components.multiselect.tagPlaceholder')"
        :selectLabel="$t('components.multiselect.selectLabel')"
        @input="$emit('input', selectedMarket)"
        :disabled="disabled"
    >
      <template slot="option" slot-scope="props">
        <span :class="`flag-icon flag-icon-${props.option.value}`"> </span>
        <span class="option-title">{{ props.option.text }}</span>
      </template>
    </multiselect>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import {mapGetters} from "vuex";

export default {
  name: "MarketPlaceComponent",
  components: {
    Multiselect
  },
  props: {
    value: {
      default: null
    },
    multiple: {
      default: true,
      type: Boolean
    },
    invalid: {
      default: false,
      type: Boolean
    },
    all: {
      default: false,
      type: Boolean
    },
    selectedMarketplaceIds: {
      default: function () {
        return []
      }
    },
    disabled: {
      default: false,
      type: Boolean
    }
  },
  data() {
    return {
      selectedMarket: null,
    }
  },
  watch: {
    selectedMarketplaceIds(ids) {
      if (ids.length > 0) {
        ids.map(id => {
          this.selectedMarket = []
          this.selectedMarket.push(this.marketplaces.find(x => x.marketplace_id === id))
        })
      }
    }
  },
  computed: {
    ...mapGetters('marketplaces', ['marketplaces']),
    filteredMarketPlaces() {
      if (!this.all && !this.region) {
        return this.marketplaces.filter(item => {
          return this.$auth.user().marketplaces.includes(item.marketplace_id)
        })
      }
      return this.marketplaces
    }
  }
}
</script>

<style scoped>
.option-title {
  margin-left: 6px;
}

.invalid /deep/ .multiselect__tags {
  border-color: #f46a6a !important;
}
</style>